{
  "title": "Paramètres",
  "panel": {
    "createTitle": "Créer {{title}}",
    "updateTitle": "Mettre à jour {{title}}",
    "createDescription": "Créer {{title}}.",
    "updateDescription": "Mettre à jour {{title}}.",
    "removeTitle": "Supprimer {{title}}",
    "removeText": "Es-tu sûr de vouloir supprimer {{title}} ? Cette action est irréversible.",
    "closePanel": "Fermer le panneau",
    "remove": "Supprimer",
    "test": "Tester",
    "ok": "OK !",
    "error": "ERREUR",
    "cancel": "Annuler",
    "create": "Créer",
    "save": "Enregistrer"
  },
  "nav": {
    "application": "Application",
    "logs": "Journaux",
    "indexers": "Indexeurs",
    "irc": "IRC",
    "feeds": "Feeds",
    "lists": "Listes",
    "clients": "Clients",
    "notifications": "Notifications",
    "apiKeys": "Clés API",
    "proxies": "Proxys",
    "releases": "Releases",
    "account": "Compte"
  },
  "application": {
    "title": "Application",
    "description": "Paramètres de l'application. Modifier dans config.toml et redémarrer pour appliquer.",
    "host": "Hôte",
    "port": "Port",
    "baseUrl": "URL de base",
    "version": "Version",
    "commit": "Commit",
    "buildDate": "Date de build",
    "application": "Application",
    "configPath": "Chemin de configuration",
    "database": "Base de données",
    "webuiDebugMode": "Mode débogage WebUI",
    "checkForUpdates": "Vérifier les mises à jour",
    "checkForUpdatesDescription": "Être notifié des nouvelles mises à jour.",
    "theme": "Thème",
    "themeDescription": "Choisir entre le thème clair, sombre ou celui du système.",
    "languageDescription": "Choisir la langue utilisée dans le WebUI.",
    "updateEnabled": "Tu seras maintenant notifié des nouvelles mises à jour.",
    "updateDisabled": "Tu ne seras plus notifié des nouvelles mises à jour.",
    "updateAvailable": "{{name}} disponible !"
  },
  "account": {
    "title": "Compte",
    "description": "Gérer les paramètres du compte.",
    "required": "Requis",
    "passwordsDoNotMatch": "Les mots de passe ne correspondent pas !",
    "updateSuccess": "Utilisateur mis à jour avec succès. Veuillez te reconnecter !",
    "updateError": "Erreur lors de la mise à jour des identifiants. As-tu fourni le bon mot de passe actuel ?",
    "changeCredentialsTitle": "Modifier les identifiants",
    "changeCredentialsDescription": "Le nom d'utilisateur et le mot de passe peuvent être modifiés séparément ou simultanément. Note que tu seras déconnecté après la modification des identifiants.",
    "currentUsername": "Nom d'utilisateur actuel",
    "newUsername": "Nouveau nom d'utilisateur",
    "optional": "Facultatif",
    "currentPassword": "Mot de passe actuel",
    "requiredIfUpdatingCredentials": "Requis lors de la mise à jour des identifiants",
    "newPassword": "Nouveau mot de passe",
    "confirmNewPassword": "Confirmer le nouveau mot de passe",
    "save": "Enregistrer",
    "identityProvider": "ton fournisseur d'identité",
    "oidcTitle": "Compte OpenID Connect",
    "oidcDescription": "Tes identifiants sont gérés par ton fournisseur OpenID Connect. Pour modifier ton nom d'utilisateur, visite la page des paramètres de ton fournisseur et reconnecte-toi.",
    "authenticatedViaOidc": "Authentifié via OpenID Connect"
  },
  "logsPage": {
    "title": "Journaux",
    "description": "Configurer le niveau de journalisation, la rotation des journaux, etc. Tu peux télécharger tes anciens fichiers journaux ci-dessous.",
    "chooseType": "Choisir un type",
    "updated": "Configuration mise à jour avec succès !",
    "path": "Chemin",
    "setInConfig": "Défini dans config.toml",
    "notSet": "Non défini !",
    "level": "Niveau",
    "logLevel": "Niveau de journalisation",
    "maxSize": "Taille max.",
    "maxBackups": "Sauvegardes max."
  },
  "regexPlayground": {
    "title": "Terrain de jeu Regex",
    "description": "Terrain de jeu Regex. Expérimente avec tes filtres ici. En développement.",
    "regexFilter": "Filtre RegExp",
    "linesToMatch": "Lignes à faire correspondre",
    "matches": "Correspondances"
  },
  "apiKey": {
    "createTitle": "Créer une clé API",
    "description": "Ajouter une nouvelle clé API.",
    "created": "La clé API {{name}} a été ajoutée",
    "deleted": "La clé API {{name}} a été supprimée",
    "name": "Nom",
    "key": "Clé",
    "required": "Requis",
    "closePanel": "Fermer le panneau",
    "cancel": "Annuler",
    "create": "Créer",
    "listTitle": "Clés API",
    "listDescription": "Gérer tes clés API autobrr ici.",
    "addNew": "Ajouter",
    "noItems": "Aucune clé API",
    "createCta": "Créer une clé API",
    "removeTitle": "Supprimer la clé API : {{name}}",
    "removeText": "Es-tu sûr de vouloir supprimer cette clé API ? Cette action est irréversible.",
    "deleteKey": "Supprimer la clé"
  },
  "irc": {
    "listTitle": "IRC",
    "listDescription": "Réseaux et canaux IRC. Cliquer sur un réseau pour voir le statut des canaux.",
    "addNew": "Ajouter",
    "networkHealthy": "Réseau en bonne santé",
    "networkUnhealthy": "Réseau en mauvaise santé",
    "networkDisabled": "Réseau désactivé",
    "collapseTitle": "réduire",
    "expandTitle": "développer",
    "collapse": "Réduire",
    "expand": "Développer",
    "network": "Réseau",
    "noNetworks": "Aucun réseau",
    "noNetworksSubtitle": "Normalement configuré via les indexeurs",
    "addNewNetwork": "Ajouter un nouveau réseau",
    "toggleSuccess": "{{name}} a été {{state}} avec succès.",
    "enabledState": "activé",
    "disabledState": "désactivé",
    "connectedSince": "Connecté depuis : {{time}}",
    "tlsSecured": "Sécurisé avec TLS",
    "tlsInsecure": "Non sécurisé, sans TLS",
    "channel": "Canal",
    "monitoringSince": "Surveillance depuis",
    "lastAnnounce": "Dernière annonce",
    "monitoring": "surveillance",
    "hide": "Masquer",
    "view": "Afficher",
    "networkDeleted": "Le réseau {{name}} a été supprimé",
    "networkRestarted": "{{name}} a été redémarré avec succès",
    "removeNetworkTitle": "Supprimer le réseau : {{name}}",
    "removeNetworkText": "Es-tu sûr de vouloir supprimer ce réseau ? Cette action est irréversible.",
    "edit": "Modifier",
    "restart": "Redémarrer",
    "delete": "Supprimer",
    "announceReprocessed": "Annonce envoyée pour retraitement !",
    "reprocessAnnounce": "Retraiter l'annonce",
    "options": "Options",
    "scrollOnNewMessage": "Défiler vers le bas lors d'un nouveau message",
    "title": "Réseau",
    "addWarning": "AJOUTER LES RÉSEAUX VIA LES INDEXEURS ! N'UTILISER QUE SI TU AS SUPPRIMÉ DES RÉSEAUX",
    "added": "Réseau IRC ajouté. Veuillez attendre jusqu'à 30 secondes pour que le réseau se connecte.",
    "addFailed": "Le réseau IRC n'a pas pu être ajouté",
    "updated": "{{name}} a été mis à jour avec succès",
    "deleted": "{{name}} a été supprimé.",
    "required": "Requis",
    "name": "Nom",
    "enabled": "Activé",
    "server": "Serveur",
    "serverPlaceholder": "Adresse : ex. irc.server.net",
    "port": "Port",
    "portPlaceholder": "ex. 6667",
    "tls": "TLS",
    "skipTls": "Ignorer la vérification TLS (non sécurisé)",
    "password": "Mot de passe",
    "passwordHelp": "Mot de passe du réseau",
    "passwordUpdateHelp": "Mot de passe du réseau, rarement utilisé.",
    "nick": "Nick",
    "nickPlaceholderAdd": "nick du bot",
    "nickPlaceholderUpdate": "nick",
    "authAccount": "Compte d'authentification",
    "authAccountPlaceholder": "Compte d'authentification",
    "authPassword": "Mot de passe d'authentification",
    "inviteCommand": "Commande d'invitation",
    "channels": "Canaux",
    "channelsDesc": "Canaux à rejoindre.",
    "channelsUpdateDesc": "Les canaux sont ajoutés lors de la configuration des indexeurs IRC. Ne pas modifier sauf si tu sais ce que tu fais.",
    "channelPassword": "Mot de passe du canal",
    "remove": "Supprimer",
    "noChannels": "Aucun canal !",
    "addChannel": "Ajouter un canal",
    "bouncer": "Bouncer (BNC)",
    "bouncerAddress": "Adresse du bouncer",
    "bouncerAddressHelp": "Adresse : ex. bouncer.server.net:6697",
    "botMode": "IRCv3 Bot Mode",
    "proxy": "Proxy",
    "proxyDesc": "Définir un proxy pour la connexion au serveur IRC.",
    "selectProxy": "Sélectionner un proxy",
    "selectProxyPlaceholder": "Sélectionner un proxy",
    "identification": "Identification",
    "identificationDesc": "S'identifier avec SASL ou NickServ. La plupart des réseaux prennent en charge SASL, mais pas tous.",
    "mechanism": "Mécanisme",
    "account": "Compte",
    "accountHelp": "Compte NickServ / SASL. Pour les nicks groupés, essayer le principal.",
    "passwordSaslHelp": "Mot de passe NickServ / SASL.",
    "chooseType": "Choisir un type"
  },
  "releases": {
    "warningTitle": "Avertissement :",
    "warningBody": "Cette section gère la suppression de l'historique des releases. Les tâches de nettoyage automatisées s'exécutent selon un calendrier, tandis que la suppression manuelle permet un nettoyage ponctuel immédiat. Ces deux opérations suppriment définitivement les données et sont irréversibles.",
    "olderThan": "Plus ancien que",
    "olderThanDesc": "L'ancienneté requise des releases avant suppression (requis pour la suppression automatisée et manuelle)",
    "indexers": "Indexeurs",
    "indexersDesc": "Filtre optionnel (si aucun sélectionné, s'applique à tous les indexeurs)",
    "releaseStatuses": "Statuts des releases",
    "releaseStatusesDesc": "Filtre optionnel (si aucun sélectionné, s'applique à tous les statuts)",
    "duplicateProfilesTitle": "Profils de doublons de release",
    "duplicateProfilesDesc": "Gérer les profils de doublons.",
    "cleanupJobsTitle": "Tâches de nettoyage des releases",
    "cleanupJobsDesc": "Planifier le nettoyage automatique des anciennes releases avec des filtres personnalisés.",
    "addNew": "Ajouter",
    "edit": "Modifier",
    "enabled": "Activé",
    "name": "Nom",
    "lastRun": "Dernière exécution",
    "nextRun": "Prochaine exécution",
    "runNow": "Exécuter maintenant",
    "delete": "Supprimer",
    "never": "Jamais",
    "deleteReleaseHistory": "Supprimer l'historique des releases",
    "deleteReleaseHistoryDesc": "Sélectionner les critères ci-dessous pour supprimer définitivement les enregistrements d'historique plus anciens que l'âge choisi et correspondant optionnellement aux indexeurs et statuts sélectionnés :",
    "removeReleases": "Supprimer les releases",
    "invalidAge": "Veuillez sélectionner un âge valide.",
    "invalidAgeExample": "Veuillez entrer un âge valide. Par exemple : 6 mois ou 1 an.",
    "allDeleted": "Toutes les releases correspondant aux critères ont été supprimées.",
    "olderThanDeleted": "Les releases plus anciennes que {{duration}} ont été supprimées.",
    "allIndexers": "tous les indexeurs",
    "selectedIndexers": "les indexeurs sélectionnés",
    "removeCleanupJobTitle": "Supprimer la tâche de nettoyage : {{name}}",
    "removeCleanupJobText": "Es-tu sûr de vouloir supprimer cette tâche de nettoyage ? Cette action est irréversible.",
    "cleanupJobToggled": "{{name}} {{state}}",
    "cleanupJobTriggered": "{{name}} déclenché",
    "cleanupJobDeleted": "{{name}} supprimé",
    "cleanupJobEnabled": "activé",
    "cleanupJobDisabled": "désactivé",
    "duplicateFieldTitles": {
      "releaseName": "Nom de la release",
      "hash": "Hash normalisé du nom de la release. Utiliser avec Nom de la release pour une correspondance exacte",
      "title": "Titre parsé",
      "subTitle": "Sous-titre parsé comme le nom de l'épisode",
      "group": "Groupe de release",
      "year": "Année",
      "month": "Mois",
      "day": "Jour",
      "source": "Source",
      "resolution": "Résolution",
      "codec": "Codec",
      "container": "Conteneur",
      "dynamicRange": "Plage dynamique (HDR, DV)",
      "audio": "Formats audio",
      "season": "Numéro de saison",
      "episode": "Numéro d'épisode",
      "website": "Site web/Service",
      "proper": "Scene proper",
      "repack": "Scene repack",
      "edition": "Édition (ex. Collector's Edition) et coupe (ex. Director's Cut)",
      "language": "Langue et région"
    },
    "noDuplicateProfiles": "Aucun profil de doublons de release",
    "addNewProfile": "Ajouter un nouveau profil",
    "noCleanupJobs": "Aucune tâche de nettoyage",
    "createCleanupSchedules": "Créer des planifications de nettoyage automatisées",
    "addNewJob": "Ajouter une nouvelle tâche",
    "removeReleasesText": "Tu es sur le point de {{scope}}.",
    "removeReleasesScopeAll": "supprimer tous les enregistrements d'historique de releases pour {{indexers}}{{statuses}}",
    "removeReleasesScopeOlder": "supprimer définitivement tous les enregistrements d'historique de releases plus anciens que {{duration}} pour {{indexers}}{{statuses}}",
    "removeReleasesStatuses": " et avec les statuts de release suivants : {{statuses}}",
    "duration": {
      "allTime": "toute la période",
      "hour1": "1 heure",
      "hours12": "12 heures",
      "day1": "1 jour",
      "week1": "1 semaine",
      "month1": "1 mois",
      "months3": "3 mois",
      "months6": "6 mois",
      "year1": "1 an",
      "invalid": "Durée invalide"
    }
  },
  "forms": {
    "downloadClient": {
      "remove": "Supprimer",
      "test": "Tester",
      "ok": "OK !",
      "error": "ERREUR",
      "cancel": "Annuler",
      "create": "Créer",
      "save": "Enregistrer",
      "added": "Client ajouté",
      "addFailed": "Le client n'a pas pu être ajouté",
      "updated": "{{name}} a été mis à jour avec succès",
      "deleted": "{{name}} a été supprimé.",
      "addTitle": "Ajouter un client",
      "addDescription": "Ajouter un client de téléchargement.",
      "editTitle": "Modifier le client",
      "editDescription": "Modifier les paramètres du client de téléchargement.",
      "removeTitle": "Supprimer le client de téléchargement",
      "removeText": "Es-tu sûr de vouloir supprimer ce client de téléchargement ? Cette action est irréversible.",
      "closePanel": "Fermer le panneau",
      "name": "Nom",
      "enabled": "Activé",
      "type": "Type",
      "host": "Hôte",
      "port": "Port",
      "tls": "TLS",
      "skipTls": "Ignorer la vérification TLS (non sécurisé)",
      "username": "Nom d'utilisateur",
      "password": "Mot de passe",
      "apiKey": "Clé API",
      "authToken": "Token d'authentification",
      "basicAuth": "Authentification de base",
      "auth": "Authentification",
      "authType": "Type d'authentification",
      "selectAuthType": "Sélectionner le type d'authentification",
      "authTypeTooltip": "Dans la plupart des cas, il s'agit de l'authentification de base, mais certains fournisseurs utilisent l'authentification Digest.",
      "hostHelpDeluge": "ex. client.domaine.fr, domaine.fr/client, domaine.fr:port",
      "hostHelpArr": "URL complète http(s)://domaine.fr et/ou sous-domaine/sous-dossier",
      "hostHelpQbit": "ex. http(s)://client.domaine.fr, http(s)://domaine.fr/qbittorrent, http://domaine.fr:port",
      "hostHelpPorla": "ex. http(s)://client.domaine.fr, http(s)://domaine.fr/porla, http://domaine.fr:port",
      "hostHelpAria2": "ex. http://localhost:6800, http(s)://domaine.fr/aria2",
      "rpcSecret": "Jeton RPC",
      "rpcSecretHelp": "La valeur de --rpc-secret. Laissez vide si aria2 fonctionne sans jeton.",
      "hostHelpRTorrent": "ex. http(s)://client.domaine.fr/RPC2, http(s)://domaine.fr/client, http(s)://domaine.fr/RPC2",
      "hostHelpTransmission": "ex. http(s)://client.domaine.fr, http(s)://domaine.fr/transmission",
      "hostHelpSabnzbd": "ex. http://ip:port ou https://url.com/sabnzbd",
      "hostHelpNzbget": "ex. http://localhost:6789",
      "daemonPort": "Port du démon",
      "webUiPortQbit": "Port WebUI pour qBittorrent",
      "transmissionPort": "Port pour Transmission",
      "sabnzbdPort": "Port pour SABnzbd",
      "guidesDeluge": "Consulter les guides de connexion à Deluge pour différents types de serveurs dans notre documentation.",
      "guidesArr": "Consulter les guides de connexion à la suite *arr pour différents types de serveurs dans notre documentation.",
      "guidesQbit": "Consulter les guides de connexion à qBittorrent pour différents types de serveurs dans notre documentation.",
      "guidesRTorrent": "Consulter les guides de connexion à rTorrent pour différents types de serveurs dans notre documentation.",
      "guidesTransmission": "Consulter les guides de connexion à Transmission pour différents types de serveurs dans notre documentation.",
      "guidesSabnzbd": "Consulter nos guides de connexion à SABnzbd pour différents types de serveurs dans notre documentation.",
      "dedicatedServers": "Serveurs dédiés :",
      "sharedSeedboxProviders": "Fournisseurs de seedbox partagée :",
      "rulesTitle": "Règles",
      "rulesDescriptionBasic": "Gérer les téléchargements maximum.",
      "rulesDescriptionAdvanced": "Gérer les téléchargements maximum, etc.",
      "maxActiveDownloads": "Téléchargements actifs max.",
      "maxActiveDownloadsTooltip": "Limiter le nombre de téléchargements actifs (0 = illimité) pour maximiser la bande passante et l'espace disque disponibles.",
      "seeRecommendations": "Voir les recommandations pour différents types de serveurs ici :",
      "downloadClientTitle": "Client de téléchargement",
      "downloadClientDescription": "Remplacer le client de téléchargement à utiliser. Peut aussi être remplacé par action de filtre.",
      "clientName": "Nom du client",
      "clientNameTooltip": "Spécifier quel client l'arr doit utiliser par défaut. Peut être remplacé par action de filtre.",
      "clientIdDeprecated": "ID du client DÉPRÉCIÉ",
      "clientIdDeprecatedTooltip": "DÉPRÉCIÉ : Utiliser le champ Nom du client à la place.",
      "ignoreSlowTorrents": "Ignorer les torrents lents",
      "ignoreCondition": "Condition d'ignorance",
      "selectIgnoreCondition": "Sélectionner la condition d'ignorance",
      "ignoreConditionTooltip": "Choisir si le paramètre de téléchargements actifs max. doit être respecté ou ignoré avant de vérifier les seuils de vitesse.",
      "downloadSpeedThreshold": "Seuil de vitesse de téléchargement",
      "uploadSpeedThreshold": "Seuil de vitesse d'envoi",
      "speedThresholdPlaceholder": "en KB/s",
      "downloadSpeedThresholdHelp": "Si la vitesse de téléchargement est inférieure à ce seuil quand le max. de téléchargements actifs est atteint, télécharger quand même. KB/s",
      "uploadSpeedThresholdHelp": "Si la vitesse d'envoi est inférieure à ce seuil quand le max. de téléchargements actifs est atteint, télécharger quand même. KB/s"
    },
    "feed": {
      "title": "Feed",
      "updated": "{{name}} a été mis à jour avec succès",
      "deleted": "{{name}} a été supprimé.",
      "testOk": "Test {{name}} OK !",
      "name": "Nom",
      "type": "Type",
      "enabled": "Activé",
      "warningTitle": "Avertissement : des indexeurs pourraient te bannir pour un intervalle trop court !",
      "warningText": "Lire les règles de l'indexeur.",
      "url": "URL",
      "torznabUrlHelp": "URL Torznab. N'utiliser que l'URL sans paramètres supplémentaires.",
      "newznabUrlHelp": "URL Newznab. N'utiliser que l'URL sans paramètres supplémentaires.",
      "rssUrlHelp": "URL RSS",
      "urlFormatTitle": "Prowlarr et Jackett ont des formats différents :",
      "prowlarr": "Prowlarr",
      "jackett": "Jackett",
      "downloadType": "Type de téléchargement",
      "apiKey": "Clé API",
      "skipTls": "Ignorer la vérification TLS (non sécurisé)",
      "refreshInterval": "Intervalle d'actualisation",
      "refreshIntervalHelp": "Minutes. Recommandé : 15-30. Trop bas risque un bannissement.",
      "refreshTimeout": "Délai d'expiration d'actualisation",
      "refreshTimeoutHelp": "Secondes avant l'annulation de l'actualisation.",
      "maxAge": "Âge max.",
      "maxAgeHelp": "Âge maximum du contenu du feed en secondes. Utiliser 0 pour désactiver le filtre d'âge et traiter tous les éléments.",
      "cookie": "Cookie",
      "cookieHelp": "Rarement utilisé",
      "categoriesTitle": "Catégories",
      "categoriesDescription": "Récupérer les catégories disponibles et sélectionner celles à inclure.",
      "fetch": "Récupérer",
      "fetching": "Récupération en cours",
      "refetch": "Récupérer à nouveau",
      "fetchFailed": "Échec de la récupération des catégories",
      "noCategories": "Aucune catégorie trouvée.",
      "fetchToSelect": "Récupérer les catégories pour les sélectionner."
    },
    "list": {
      "added": "Liste ajoutée !",
      "addFailed": "La liste n'a pas pu être ajoutée",
      "updated": "{{name}} a été mis à jour avec succès",
      "deleted": "{{name}} a été supprimé.",
      "name": "Nom",
      "type": "Type",
      "enabled": "Activé",
      "filters": "Filtres",
      "addTitle": "Ajouter une liste",
      "updateTitle": "Mettre à jour la liste",
      "description": "Mettre à jour automatiquement les filtres depuis les listes et les ARRs.",
      "closePanel": "Fermer le panneau",
      "chooseType": "Choisir un type",
      "chooseClient": "Choisir un client",
      "selectClient": "Sélectionner un client",
      "selectClientLabel": "Sélectionner un client",
      "filtersDescription": "Sélectionner les filtres à mettre à jour pour cette liste.",
      "cancel": "Annuler",
      "remove": "Supprimer",
      "save": "Enregistrer",
      "saving": "Enregistrement...",
      "selectSomeItems": "Sélectionner...",
      "allItemsSelected": "Tous les éléments sont sélectionnés",
      "selectAll": "Tout sélectionner",
      "search": "Rechercher",
      "noOptions": "Aucune option",
      "removeTitle": "Supprimer {{name}}",
      "removeText": "Es-tu sûr de vouloir supprimer {{name}} ? Cette action est irréversible.",
      "required": "Requis",
      "settingsLegend": "Paramètres",
      "source": "Source",
      "sourceList": "Liste source",
      "arrSourceDescription": "Mettre à jour les filtres depuis les titres dans Radarr, Sonarr, Lidarr, Readarr ou Whisparr.",
      "traktSourceDescription": "Utiliser une liste Trakt ou l'une des listes hébergées par autobrr par défaut.",
      "anilistSourceDescription": "Utiliser une liste AniList parmi les listes hébergées par autobrr par défaut.",
      "plaintextSourceDescription": "Utiliser une liste en texte brut avec un élément par ligne.",
      "steamSourceDescription": "Suivre les listes de souhaits Steam.",
      "metacriticSourceDescription": "Utiliser une liste Metacritic ou l'une des listes hébergées par autobrr par défaut.",
      "mdblistSourceDescription": "Utiliser une liste MDBList ou l'une des listes hébergées par autobrr par défaut.",
      "listUrl": "URL de la liste",
      "traktHelp": "Listes Trakt par défaut. Remplacer par les tiennes.",
      "traktApiKey": "Clé API",
      "traktApiKeyHelp": "Clé API Trakt. Requise pour les listes privées.",
      "matchRelease": "Correspondre à la release",
      "matchReleaseDesc": "Utiliser le champ Correspondre aux releases. Utilise le champ Films/Séries par défaut.",
      "includeUnmonitored": "Inclure les non surveillés",
      "includeUnmonitoredDesc": "Par défaut, seuls les titres surveillés sont filtrés.",
      "includeAlternateTitles": "Inclure les titres alternatifs",
      "includeAlternateTitlesDesc": "Inclure les titres alternatifs dans le filtre.",
      "skipCleanSanitize": "Contourner le nettoyage et la sanitisation et utiliser la liste telle quelle",
      "skipCleanSanitizeDesc": "Par défaut, les titres sont automatiquement sanitisés et vérifiés pour les caractères inhabituels.",
      "tagsIncluded": "Tags inclus",
      "tagsExcluded": "Tags exclus",
      "metacriticHelp": "Listes Metacritic. Remplacer par les tiennes.",
      "mdblistHelp": "Listes MDBLists.com. Remplacer par les tiennes.",
      "includeYear": "Inclure l'année",
      "includeYearDesc": "Inclure l'année de sortie dans le filtre pour les films. Nécessite Correspondre aux releases. Exemple : Film?Titre?2024*",
      "plaintextUrlHelp": "URL vers un fichier texte brut avec un élément par ligne",
      "plaintextUrlPlaceholder": "https://example.com/list.txt",
      "plaintextTooltip1": "Les listes en texte brut peuvent lire depuis des URLs HTTP et des fichiers locaux.",
      "plaintextTooltipRemote": "Distant : https://service.com/fichier.txt",
      "plaintextTooltipLocal": "Local : file:///home/utilisateur/fichier.txt",
      "url": "URL",
      "steamUrlHelp": "URL de la liste de souhaits Steam",
      "steamUrlPlaceholder": "https://store.steampowered.com/wishlist/id/NOMDUTILISATEUR/wishlistdata"
    },
    "proxy": {
      "title": "Proxy",
      "addTitle": "Ajouter un proxy",
      "addDescription": "Ajouter un proxy à utiliser avec les indexeurs ou IRC.",
      "added": "Proxy ajouté !",
      "addFailed": "Le proxy n'a pas pu être ajouté",
      "updated": "Proxy {{name}} mis à jour !",
      "updateFailed": "Le proxy n'a pas pu être mis à jour",
      "deleted": "Le proxy {{name}} a été supprimé.",
      "name": "Nom",
      "closePanel": "Fermer le panneau",
      "enabled": "Activé",
      "proxyType": "Type de proxy",
      "proxyTypeTooltip": "Type de proxy. Généralement SOCKS5.",
      "proxyTypeHelp": "Généralement SOCKS5",
      "addr": "Adresse",
      "addrHelp": "Adresse : schéma://ip:port ou schéma://domaine",
      "user": "Utilisateur",
      "userHelp": "Auth : nom d'utilisateur",
      "pass": "Mot de passe",
      "passHelp": "Auth : mot de passe",
      "test": "Tester",
      "cancel": "Annuler",
      "save": "Enregistrer"
    },
    "apiKey": {
      "createTitle": "Créer une clé API",
      "description": "Ajouter une nouvelle clé API.",
      "created": "La clé API {{name}} a été ajoutée",
      "deleted": "La clé API {{name}} a été supprimée",
      "name": "Nom",
      "key": "Clé",
      "required": "Requis",
      "closePanel": "Fermer le panneau",
      "cancel": "Annuler",
      "create": "Créer",
      "listTitle": "Clés API",
      "listDescription": "Gérer tes clés API autobrr ici.",
      "addNew": "Ajouter",
      "noItems": "Aucune clé API",
      "createCta": "Créer une clé API",
      "removeTitle": "Supprimer la clé API : {{name}}",
      "removeText": "Es-tu sûr de vouloir supprimer cette clé API ? Cette action est irréversible.",
      "deleteKey": "Supprimer la clé"
    },
    "notification": {
      "settings": "Paramètres",
      "settingsDescDiscordPrefix": "Créer une ",
      "settingsDescDiscordSuffix": " dans ton serveur.",
      "discordWebhookIntegration": "intégration webhook",
      "settingsDescNotifiarr": "Activer l'intégration autobrr et éventuellement créer une nouvelle clé API.",
      "settingsDescLunasea1": "LunaSea offre des notifications sur tous les appareils liés à ton compte (basé sur l'utilisateur) ou sur un seul appareil sans compte, via un webhook unique par appareil (basé sur l'appareil).",
      "settingsDescLunasea2Prefix": "Lire la ",
      "settingsDescLunasea2Suffix": ".",
      "lunaseaDocs": "documentation LunaSea",
      "settingsDescTelegramPrefix": "Lire comment ",
      "settingsDescTelegramSuffix": ".",
      "createBot": "créer un bot",
      "settingsDescPushoverPrefix": "Enregistrer une nouvelle ",
      "settingsDescPushoverSuffix": " et ajouter son token API ici.",
      "pushoverApplication": "application",
      "eventSounds": "Sons d'événements",
      "eventSoundsDesc": "Définir des sons personnalisés par événement",
      "settingsDescWebhook": "Envoyer une charge utile JSON autobrr générique vers une URL webhook définie par l'utilisateur.",
      "added": "Notification ajoutée !",
      "addFailed": "La notification n'a pas pu être ajoutée",
      "updated": "{{name}} a été mis à jour avec succès",
      "deleted": "{{name}} a été supprimé.",
      "required": "Requis",
      "addTitle": "Ajouter des notifications",
      "addDescription": "Déclencher des notifications sur différents événements.",
      "title": "Notification",
      "name": "Nom",
      "type": "Type",
      "enabled": "Activé",
      "chooseType": "Choisir un type",
      "closePanel": "Fermer le panneau",
      "globalEvents": "Événements globaux",
      "globalEventsDesc": "Sélectionner les événements par défaut qui se déclenchent globalement. Ils peuvent être remplacés par filtre. Tout décocher pour utiliser ce service uniquement pour les notifications spécifiques aux filtres.",
      "perFilterEvents": "Événements par filtre",
      "perFilterEventsDesc": "Cette notification est utilisée dans ces filtres.",
      "notUsedInFilters": "Non utilisé dans aucun filtre",
      "muted": "En sourdine",
      "test": "Tester",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "notificationsLegend": "Notifications",
      "defaultTone": "Par défaut (ton par défaut de l'utilisateur)",
      "webhookUrl": "URL Webhook",
      "discordWebhookPlaceholder": "https://discordapp.com/api/webhooks/xx/xx",
      "discordWebhookHelp": "URL webhook du canal Discord",
      "notifiarrApiKey": "Clé API",
      "notifiarrApiKeyHelp": "Clé API Notifiarr",
      "lunaseaWebhookPlaceholder": "https://notify.lunasea.app/v1/custom/user/TOKEN",
      "lunaseaWebhookHelp": "URL Webhook LunaSea",
      "botToken": "Token du bot",
      "botTokenHelp": "Token du bot",
      "chatId": "ID du chat",
      "chatIdHelp": "ID du chat",
      "messageThreadId": "ID du fil de messages",
      "messageThreadIdHelp": "Fil de messages (sujet) d'un Supergroupe",
      "telegramProxy": "Proxy API Telegram",
      "telegramProxyHelp": "Domaine de proxy inverse pour api.telegram.org. Nécessaire uniquement si ton réseau bloque l'API Telegram.",
      "telegramProxyPlaceholder": "http(s)://ip:port",
      "sender": "Expéditeur",
      "senderHelp": "Nom d'expéditeur personnalisé affiché en haut d'une notification",
      "senderPlaceholder": "autobrr",
      "apiToken": "Token API",
      "apiTokenHelp": "Token API",
      "userKey": "Clé utilisateur",
      "userKeyHelp": "Clé utilisateur",
      "priority": "Priorité",
      "pushoverPriorityHelp": "-2, -1, 0 (par défaut), 1 ou 2",
      "gotifyUrl": "URL Gotify",
      "gotifyUrlHelp": "URL Gotify (sans /message)",
      "gotifyUrlPlaceholder": "https://some.gotify.server.com",
      "applicationToken": "Token d'application",
      "applicationTokenHelp": "Token d'application",
      "ntfyUrl": "URL NTFY",
      "ntfyUrlHelp": "URL NTFY",
      "ntfyUrlPlaceholder": "https://ntfy.sh/mytopic",
      "username": "Nom d'utilisateur",
      "usernameHelp": "Nom d'utilisateur",
      "password": "Mot de passe",
      "passwordHelp": "Mot de passe",
      "accessToken": "Token d'accès",
      "accessTokenHelp": "Token d'accès. Utiliser celui-ci ou Nom d'utilisateur + mot de passe",
      "tags": "Tags",
      "ntfyTagsHelp": "Tags/icônes separés par des virgules pour les notifications ntfy",
      "ntfyTagsPlaceholder": "download,arr,white_check_mark",
      "ntfyPriorityHelp": "Max 5, 4, 3 (par défaut), 2, 1 Min",
      "url": "URL",
      "urlHelp": "URL",
      "shoutrrrDocsPrefix": "Consulter la documentation complète ",
      "shoutrrrServices": "Services",
      "shoutrrrUrlPlaceholder": "smtp://username:password@host:port/?from=fromAddress&to=recipient1",
      "httpMethod": "Méthode HTTP",
      "httpMethodDefault": "POST (par défaut)",
      "httpMethodTooltip": "Méthode HTTP pour la requête webhook. Par défaut POST.",
      "webhookPlaceholder": "https://example.com/webhook",
      "customHeaders": "En-têtes personnalisés",
      "customHeadersHelp": "Paires CLÉ=valeur séparées par des virgules (ex. Authorization=Bearer token,X-Custom=valeur)",
      "customHeadersPlaceholder": "Authorization=Bearer token,X-Custom-Header=valeur"
    },
    "irc": {
      "listTitle": "IRC",
      "listDescription": "Réseaux et canaux IRC. Cliquer sur un réseau pour voir le statut des canaux.",
      "addNew": "Ajouter",
      "networkHealthy": "Réseau en bonne santé",
      "networkUnhealthy": "Réseau en mauvaise santé",
      "networkDisabled": "Réseau désactivé",
      "collapseTitle": "réduire",
      "expandTitle": "développer",
      "collapse": "Réduire",
      "expand": "Développer",
      "network": "Réseau",
      "noNetworks": "Aucun réseau",
      "noNetworksSubtitle": "Normalement configuré via les indexeurs",
      "addNewNetwork": "Ajouter un nouveau réseau",
      "toggleSuccess": "{{name}} a été {{state}} avec succès.",
      "enabledState": "activé",
      "disabledState": "désactivé",
      "connectedSince": "Connecté depuis : {{time}}",
      "tlsSecured": "Sécurisé avec TLS",
      "tlsInsecure": "Non sécurisé, sans TLS",
      "channel": "Canal",
      "monitoringSince": "Surveillance depuis",
      "lastAnnounce": "Dernière annonce",
      "monitoring": "surveillance",
      "hide": "Masquer",
      "view": "Afficher",
      "networkDeleted": "Le réseau {{name}} a été supprimé",
      "networkRestarted": "{{name}} a été redémarré avec succès",
      "removeNetworkTitle": "Supprimer le réseau : {{name}}",
      "removeNetworkText": "Es-tu sûr de vouloir supprimer ce réseau ? Cette action est irréversible.",
      "edit": "Modifier",
      "restart": "Redémarrer",
      "delete": "Supprimer",
      "announceReprocessed": "Annonce envoyée pour retraitement !",
      "reprocessAnnounce": "Retraiter l'annonce",
      "options": "Options",
      "scrollOnNewMessage": "Défiler vers le bas lors d'un nouveau message",
      "title": "Réseau",
      "addWarning": "AJOUTER LES RÉSEAUX VIA LES INDEXEURS ! N'UTILISER QUE SI TU AS SUPPRIMÉ DES RÉSEAUX",
      "added": "Réseau IRC ajouté. Veuillez attendre jusqu'à 30 secondes pour que le réseau se connecte.",
      "addFailed": "Le réseau IRC n'a pas pu être ajouté",
      "updated": "{{name}} a été mis à jour avec succès",
      "deleted": "{{name}} a été supprimé.",
      "required": "Requis",
      "name": "Nom",
      "enabled": "Activé",
      "server": "Serveur",
      "serverPlaceholder": "Adresse : ex. irc.server.net",
      "port": "Port",
      "portPlaceholder": "ex. 6667",
      "tls": "TLS",
      "skipTls": "Ignorer la vérification TLS (non sécurisé)",
      "password": "Mot de passe",
      "passwordHelp": "Mot de passe du réseau",
      "passwordUpdateHelp": "Mot de passe du réseau, rarement utilisé.",
      "nick": "Nick",
      "nickPlaceholderAdd": "nick du bot",
      "nickPlaceholderUpdate": "nick",
      "authAccount": "Compte d'authentification",
      "authAccountPlaceholder": "Compte d'authentification",
      "authPassword": "Mot de passe d'authentification",
      "inviteCommand": "Commande d'invitation",
      "channels": "Canaux",
      "channelsDesc": "Canaux à rejoindre.",
      "channelsUpdateDesc": "Les canaux sont ajoutés lors de la configuration des indexeurs IRC. Ne pas modifier sauf si tu sais ce que tu fais.",
      "channelPassword": "Mot de passe du canal",
      "remove": "Supprimer",
      "noChannels": "Aucun canal !",
      "addChannel": "Ajouter un canal",
      "bouncer": "Bouncer (BNC)",
      "bouncerAddress": "Adresse du bouncer",
      "bouncerAddressHelp": "Adresse : ex. bouncer.server.net:6697",
      "botMode": "IRCv3 Bot Mode",
      "proxy": "Proxy",
      "proxyDesc": "Définir un proxy pour la connexion au serveur IRC.",
      "selectProxy": "Sélectionner un proxy",
      "selectProxyPlaceholder": "Sélectionner un proxy",
      "identification": "Identification",
      "identificationDesc": "S'identifier avec SASL ou NickServ. La plupart des réseaux prennent en charge SASL, mais pas tous.",
      "mechanism": "Mécanisme",
      "account": "Compte",
      "accountHelp": "Compte NickServ / SASL. Pour les nicks groupés, essayer le principal.",
      "passwordSaslHelp": "Mot de passe NickServ / SASL.",
      "chooseType": "Choisir un type"
    },
    "indexer": {
      "title": "Indexeur",
      "addTitle": "Ajouter un indexeur",
      "addDescription": "Ajouter un indexeur.",
      "added": "Indexeur ajouté",
      "addFailed": "L'indexeur n'a pas pu être ajouté",
      "updated": "{{name}} a été mis à jour avec succès",
      "deleted": "{{name}} a été supprimé.",
      "indexer": "Indexeur",
      "chooseIndexer": "Choisir un indexeur",
      "required": "Requis",
      "defaultValueValidation": "Valeur par défaut, veuillez modifier",
      "enabled": "Activé",
      "baseUrl": "URL de base",
      "baseUrlHelp": "Remplacer l'URL de base si elle est bloquée par ton FAI.",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "closePanel": "Fermer le panneau",
      "ircTitle": "IRC",
      "ircDesc": "Les réseaux et canaux sont configurés automatiquement en arrière-plan.",
      "torznabTitle": "Torznab",
      "torznabDesc": "Feed Torznab",
      "newznabTitle": "Newznab",
      "newznabDesc": "Feed Newznab",
      "rssTitle": "RSS",
      "rssDesc": "Feed RSS",
      "settingsIrcTitle": "IRC",
      "settingsIrcDesc": "Les réseaux et canaux sont configurés automatiquement en arrière-plan.",
      "ircGuideTooltip": "Consulter notre guide IRC si tu n'es pas familier avec IRC.",
      "name": "Nom",
      "url": "URL",
      "torznabUrlHelp": "URL Torznab. N'utiliser que l'URL sans paramètres supplémentaires.",
      "newznabUrlHelp": "URL Newznab. N'utiliser que l'URL sans paramètres supplémentaires.",
      "urlFormatTitle": "Prowlarr et Jackett ont des formats différents :",
      "prowlarr": "Prowlarr",
      "jackett": "Jackett",
      "apiKey": "Clé API",
      "downloadType": "Type de téléchargement",
      "downloadTypeTooltip": "Certains feeds doivent être forcés en Magnet.",
      "downloadTypeHelp": "Définir sur Torrent ou Magnet selon l'indexeur.",
      "downloadTypeTooltip2": "Certains feeds doivent être forcés en Magnet.",
      "categoriesTitle": "Catégories",
      "categoriesDescription": "Récupérer les catégories disponibles et sélectionner celles à inclure.",
      "fetch": "Récupérer",
      "fetching": "Récupération en cours",
      "refetch": "Récupérer à nouveau",
      "fetchFailed": "Échec de la récupération des catégories",
      "fetchNeedsUrl": "Entrer une URL pour récupérer les catégories",
      "noCategories": "Aucune catégorie trouvée.",
      "fetchToSelect": "Récupérer les catégories pour les sélectionner.",
      "testApi": "Tester l'API",
      "testApiSuccess": "Test de l'API réussi !",
      "ok": "OK !",
      "error": "ERREUR",
      "externalIdentifier": "Identifiant externe",
      "externalIdentifierHelp": "Identifiant externe pour les ARRs. Si tu utilises Prowlarr, définir comme : {{name}} (Prowlarr)",
      "externalIdentifierTooltip1": "Identifiant externe pour les ARRs afin d'activer des fonctionnalités comme les limites de seed.",
      "externalIdentifierTooltip2": "Doit correspondre au nom de l'indexeur dans ton ARR. Si tu utilises Prowlarr, ce sera probablement \"{{name}} (Prowlarr)\"",
      "secretFieldTooltip": "Ce champ n'accepte pas une URL complète. N'utiliser que des chaînes alphanumériques comme uqcdi67cibkx3an8cmdm.",
      "proxy": "Proxy",
      "proxyDesc": "Définir un proxy pour les téléchargements de fichiers .torrent et les feeds.",
      "selectProxy": "Sélectionner un proxy",
      "selectProxyPlaceholder": "Sélectionner un proxy",
      "chooseType": "Choisir un type",
      "editFeeds": "Modifier les flux RSS dans Paramètres -> Feeds"
    },
    "releaseProfile": {
      "title": "Profil de doublons",
      "added": "Profil ajouté",
      "addFailed": "Le profil n'a pas pu être ajouté",
      "deleted": "Le profil {{name}} a été supprimé !",
      "fields": {
        "name": "Nom",
        "releaseName": "Nom de la release",
        "hash": "Hash",
        "title": "Titre",
        "subTitle": "Sous-titre",
        "year": "Année",
        "month": "Mois",
        "day": "Jour",
        "source": "Source",
        "resolution": "Résolution",
        "codec": "Codec",
        "container": "Conteneur",
        "dynamicRange": "Plage dynamique",
        "audio": "Audio",
        "group": "Groupe",
        "season": "Saison",
        "episode": "Épisode",
        "website": "Site web/Service",
        "proper": "Proper",
        "repack": "Repack",
        "edition": "Édition",
        "hybrid": "Version hybride",
        "language": "Langue"
      },
      "descriptions": {
        "releaseName": "Nom complet de la release",
        "hash": "Hash normalisé du nom de la release. Utiliser avec Nom de la release pour une correspondance exacte",
        "title": "Titre parsé",
        "subTitle": "Sous-titre parsé comme le nom de l'épisode",
        "dailyReleases": "Pour les releases quotidiennes",
        "group": "Groupe de release",
        "website": "Services tels que AMZN/HULU/NF",
        "dynamicRange": "Plage dynamique (HDR, DV, etc.)",
        "edition": "Édition et coupe",
        "language": "Langue et région"
      }
    },
    "cleanupJob": {
      "title": "Tâche de nettoyage",
      "created": "Tâche de nettoyage créée",
      "createFailed": "La tâche n'a pas pu être créée",
      "updated": "Tâche mise à jour",
      "updateFailed": "La tâche n'a pas pu être mise à jour",
      "deleted": "{{name}} supprimé",
      "enableDesc": "Activer cette tâche de nettoyage",
      "namePlaceholder": "Nettoyage hebdomadaire",
      "schedule": "Planification (Cron)",
      "schedulePlaceholder": "0 3 * * *",
      "scheduleHelp": "Expression Cron. Exemples : '0 3 * * *' = quotidien à 3h, '0 */6 * * *' = toutes les 6 heures",
      "olderThan": "Plus ancien que",
      "olderThanPlaceholder": "30",
      "olderThanHelp": "Supprimer les releases plus anciennes que cette durée",
      "indexersOptional": "Indexeurs (Facultatif)",
      "statusesOptional": "Statuts (Facultatif)",
      "leaveEmptyIndexers": "Laisser vide pour appliquer à tous les indexeurs",
      "leaveEmptyStatuses": "Laisser vide pour appliquer à tous les statuts",
      "executionHistory": "Historique d'exécution",
      "lastRun": "Dernière exécution :",
      "status": "Statut :"
    }
  },
  "listScreens": {
    "common": {
      "enabled": "Activé",
      "name": "Nom",
      "type": "Type",
      "edit": "Modifier",
      "addNew": "Ajouter",
      "unknownError": "Une erreur inconnue s'est produite"
    },
    "downloadClients": {
      "title": "Clients de téléchargement",
      "description": "Gérer les clients de téléchargement.",
      "host": "Hôte",
      "noItems": "Aucun client de téléchargement",
      "addNewItem": "Ajouter un nouveau client",
      "toggleSuccess": "{{name}} a été {{state}} avec succès.",
      "enabledState": "activé",
      "disabledState": "désactivé"
    },
    "notifications": {
      "title": "Notifications",
      "description": "Configurer les services de notification et leurs déclencheurs d'événements globaux.",
      "events": "Événements",
      "filters": "Filtres",
      "noItems": "Aucune notification",
      "addNewItem": "Créer une nouvelle notification",
      "infoTitle": "Remplacements par filtre :",
      "infoBody": "Ces paramètres globaux peuvent être remplacés pour des filtres spécifiques dans l'onglet Notifications de chaque filtre. Les événements globaux sont facultatifs – tu peux créer des services de notification sans événements et les configurer uniquement au niveau des filtres. Les événements système (IRC déconnecté/reconnecté, mises à jour de l'application) utilisent toujours les paramètres globaux.",
      "toggleSuccess": "{{name}} a été {{state}} avec succès.",
      "enabledState": "activé",
      "disabledState": "désactivé"
    },
    "indexers": {
      "title": "Indexeurs",
      "description": "Paramètres des indexeurs IRC, RSS, Newznab et Torznab.",
      "descriptionGeneric": "Les feeds RSS/Newznab/Torznab génériques peuvent être ajoutés ici en sélectionnant l'un des indexeurs <strong>Génériques</strong>.",
      "implementation": "Implémentation",
      "noItems": "Aucun indexeur",
      "addNewItem": "Ajouter un nouvel indexeur",
      "updated": "{{name}} a été mis à jour avec succès"
    },
    "proxies": {
      "title": "Proxys",
      "description": "Proxys pouvant être utilisés avec les indexeurs, feeds et IRC.",
      "noItems": "Aucun proxy",
      "addNewItem": "Ajouter un nouveau proxy",
      "toggleSuccess": "Le proxy {{name}} a été {{state}} avec succès.",
      "toggleError": "Le statut du proxy n'a pas pu être mis à jour",
      "enabledState": "activé",
      "disabledState": "désactivé"
    },
    "lists": {
      "title": "Listes",
      "description": "Les listes peuvent mettre à jour automatiquement tes filtres depuis les ARRs ou d'autres sources.",
      "filters": "Filtres",
      "noItems": "Aucune liste",
      "addNewItem": "Ajouter une nouvelle liste",
      "toggleSuccess": "La liste {{name}} a été {{state}} avec succès.",
      "toggleError": "Le statut de la liste n'a pas pu être mis à jour",
      "refreshSuccess": "La liste {{name}} a été récupérée avec succès.",
      "refreshError": "Échec de l'actualisation de {{name}}. Erreur : {{error}}",
      "deleted": "{{name}} a été supprimé.",
      "removeTitle": "Supprimer la liste : {{name}}",
      "removeText": "Es-tu sûr de vouloir supprimer cette liste ? Cette action est irréversible.",
      "copyId": "Copier l'ID de la liste",
      "copyIdSuccess": "ID de la liste {{id}} copié dans le presse-papiers.",
      "refresh": "Actualiser",
      "delete": "Supprimer",
      "enabledState": "activée",
      "disabledState": "désactivée"
    },
    "feeds": {
      "title": "Feeds",
      "description": "Gérer les feeds RSS, Newznab et Torznab.",
      "lastRun": "Dernière exécution",
      "nextRun": "Prochaine exécution",
      "noItems": "Aucun feed",
      "noItemsDesc": "Configurer via les indexeurs",
      "toggleSuccess": "{{name}} a été {{state}} avec succès.",
      "enabledState": "activé",
      "disabledState": "désactivé",
      "deleted": "Le feed {{name}} a été supprimé",
      "cacheCleared": "Le cache du feed {{name}} a été effacé !",
      "forceRunSuccess": "Le feed {{name}} a été exécuté de force avec succès.",
      "forceRunError": "Échec de l'exécution forcée de {{name}}. Erreur : {{error}}",
      "removeTitle": "Supprimer le feed : {{name}}",
      "removeText": "Es-tu sûr de vouloir supprimer ce feed ? Cette action est irréversible.",
      "removeCacheTitle": "Supprimer le cache du feed : {{name}}",
      "removeCacheText": "Es-tu sûr de vouloir supprimer le cache du feed ? Cette action est irréversible.",
      "forceRunTitle": "Forcer le feed : {{name}}",
      "forceRunText": "Es-tu sûr de vouloir forcer le feed {{name}} ? Le respect des règles d'intervalle RSS est crucial pour éviter d'éventuels bannissements IP.",
      "toggle": "Activer/Désactiver",
      "forceRun": "Forcer l'exécution",
      "viewLatestRun": "Voir la dernière exécution",
      "clearCache": "Effacer le cache du feed",
      "clearCacheTitle": "Effacer manuellement tout le cache du feed",
      "delete": "Supprimer"
    }
  }
}
